import {Injectable, signal} from '@angular/core';
import {Subject} from 'rxjs';

export interface MenuHoverState {
    label: string | null;
    icon: string | null;
    hoveredCode: string | null;
    element: HTMLElement | null;
}

@Injectable({ providedIn: 'root' })
export class MenuHoverService {
    hoverState = signal<MenuHoverState>({
        label: null,
        icon: null,
        hoveredCode: null,
        element: null,
    });

    setHover(label: string, icon: string, hoveredCode: string, element: HTMLElement): void {
        this.clearHover();
        this.hoverState.set({ label, icon, hoveredCode, element });
    }

    clearHover(): void {
        this.hoverState.set({ label: null, icon: null, element: null, hoveredCode: null });
    }

    hoverItemClicked$ = new Subject<string>();
    triggerHoverItemClick(hoveredCode: string | null | undefined): void {
        this.hoverItemClicked$.next(hoveredCode ?? '');
    }
}
